module.exports = __webpack_public_path__ + "14c59e87.svg";


//////////////////
// WEBPACK FOOTER
// ./public/SVG/ic_calendar.svg
// module id = 1303
// module chunks = 0 1